import { render, staticRenderFns } from "./ChatbotMaterials.vue?vue&type=template&id=150ad35c"
import script from "./ChatbotMaterials.vue?vue&type=script&lang=js"
export * from "./ChatbotMaterials.vue?vue&type=script&lang=js"
import style0 from "./ChatbotMaterials.vue?vue&type=style&index=0&id=150ad35c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports